<template>
<div style="overflow: hidden;">
  <v-layout
    class="inner-pages"
    :style="{height: $store.getters.getAppHeight + 'px'}"
    column>

    <quiz-header />

    <v-flex id="scroll-target"
            class="sfh-login-form background-image ">
      <v-layout column>
        <v-flex  >
          <v-layout row wrap >
          <!------------- CONTENT  --------------->

            <v-layout row wrap align-center justify-center >
              <v-flex xs12 >
                <v-container class="pa-0">

                  <v-layout  v-if="questions.length > 0">

                    <v-flex text-xs-center class="">
                      <v-stepper v-model="e1" class="question-stepper">
                        <v-stepper-items>
                          <v-stepper-content
                            class="pa-0"
                            v-touch="{
                                        left: () => swipe('Left'),
                                        right: () => swipe('Right')
                                      }"
                           :style="{height: appHeight + 'px' }"
                           v-for="(question, index) in questions" :key="'view_'+index"
                           :step="index + 1"
                          >
                            <v-img class="grey lighten-3"
                                   contain
                                   :height="imageHeight" transition="fade-transition"
                                   :src="apiUrl+'/ws/playerservice'+question.imageResource.resourceurl">
                              <template v-slot:placeholder>
                                <v-layout
                                  fill-height
                                  align-center
                                  justify-center
                                  ma-0
                                >
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>

                                </v-layout>
                              </template>

                              <v-layout row align-center justify-center  v-if="typeof question.score.scoredValue !== 'undefined'"
                                        class="container grid-list-xl ">
                                <v-flex class="label bottom wrapword white--text pa-2" >
                                  <v-layout row>
                                    <v-flex xs10 class="hide-overflow font-weight-bold">{{question.imageResource.caption}}</v-flex>
                                    <v-flex xs2  class="text-xs-right" style="padding:10px;">
<!--                                      <v-chip small class="ma-0 font-weight-bold"-->
<!--                                              :text-color="question.score.scoredValue === 0?'red':'green'"-->
<!--                                              color="grey lighten-2" label>-->
<!--                                        {{question.score.scoredValue}}/{{question.scoreValue}}</v-chip>-->
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>

                              <v-layout class="label bottom" v-if="typeof question.score.scoredValue !== 'undefined'"
                                        style="background: transparent;" text-xs-right pb-5 ma-0 pr-0>
                                <v-flex class="text-xs-right cursor-pointer pl-0" @click="openCitation(question)">
                                  <img
                                    height="40"
                                    alt="recall"
                                    src="static/images/recall_info_button.png"/>
                                </v-flex>
                              </v-layout>
                            </v-img>
                            <v-flex class="pb-2">
                              <v-flex text-xs-left class="scrollbar scroll-style-15 pa-2"
                                      v-html="question.textResource.textcontent"
                                      :style="textContentStyleObject(question)"
                              ></v-flex>
                            </v-flex>
                            <!---------- BUTTONS --------------------->
                            <v-flex class="">
                              <v-layout column>
                                <v-flex class="pa-0 ">
                                  <v-btn-toggle
                                    v-model="formatting"
                                    class="answers-toggle elevation-0"
                                  >
                                    <v-container grid-list-md class="px-2 py-0">
                                      <v-layout wrap class="button-layout">
                                        <v-flex :class="question.answers.length > 2 ?'':' '"
                                                :key="x"
                                                class="button-flex xs12"
                                                v-if="question.answers.length > 1"
                                                v-for="(answer,x) in question.answers">

                                          <v-btn v-if="typeof question.score.scoredValue === 'undefined'" :value="answer.answer_id"
                                                 small
                                                 @click="updateAnswerTxt(answer)" outline
                                                 color="secondary darken-4" active-class="option-active">
                                            <span class="quiz-option">{{answer.text}}</span>
                                            <span v-if="answer.is_correct === 0 && isDev">*</span>
                                          </v-btn>

                                          <v-btn  color="secondary darken-4" v-else-if="question.score.memberAnswers.includes(answer.answer_id) === true"
                                                  small
                                                  :class="question.score.scoredValue > 0 && answer.is_correct === 0 ? 'correct-answer' : 'incorrect-answer'"
                                                  disabled outline>
                                            <v-spacer></v-spacer>
                                            <div class="btn-answer"><span class="quiz-option">{{answer.text}}</span></div>
                                            <v-spacer></v-spacer>
                                            <i v-if="question.score.memberAnswers.includes(answer.answer_id) && question.score.scoredValue > 0 && answer.is_correct === 0 "
                                               aria-hidden="true" class="material-icons">done</i>
                                            <i v-else aria-hidden="true" class="material-icons">clear</i>
                                          </v-btn>

                                          <v-btn color="secondary darken-4" outline disabled v-else-if="parseInt(answer.is_correct) === 0"
                                                 small
                                                 class="puzzle-action-btn">
                                            <v-spacer></v-spacer>
                                            <div class="btn-answer"><span class="quiz-option">{{answer.text}}</span></div>
                                            <v-spacer></v-spacer>
                                            <i aria-hidden="true" class="material-icons">done</i>
                                          </v-btn>

                                          <v-btn disabled outline color="secondary darken-4"
                                                 v-else small
                                                 class="puzzle-action-btn"><span class="quiz-option">{{answer.text}}</span></v-btn>

                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-btn-toggle>
                                </v-flex>
                                <v-flex  class="pa-0" v-if="question.answers.length <= 1">
                                  <v-container grid-list-md class="px-2 py-0">
                                    <v-layout wrap align-center justify-center >
                                      <v-flex class="xs12">

                                        <v-text-field
                                          :autofocus=true
                                          outline
                                          :success="(typeof question.score.scoredValue !== 'undefined') &&
                                      (question.score.scoredValue > 0)"
                                          :error-messages="(typeof question.score.scoredValue !== 'undefined') &&
                                      (question.score.scoredValue === 0) ? '<strong>CORRECT ANSWER: </strong>'+question.answers[0].text : null"
                                          :append-icon="(typeof question.score.scoredValue === 'undefined')? '' :
                                      (question.score.scoredValue > 0)?'done':'clear'"
                                          label="Answer"
                                          :background-color="(typeof question.score.scoredValue === 'undefined') ? null :
                                      (question.score.scoredValue > 0) ? 'success' : 'error'"
                                          :readonly="typeof question.score.scoredValue !== 'undefined'"
                                          :value="typeof question.score.scoredValue === 'undefined' ? null : question.score.responseText"
                                          @input="updateFitb($event)"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-flex>
                                <v-flex  class="pa-0 mt-2">
                                  <v-layout row>
                                    <v-flex class="text-xs-left pr-0">
                                      <v-tooltip top color="blue darken-4" :disabled="tokens > 0 || (typeof question.score.scoredValue !== 'undefined')">
                                        <template v-slot:activator="{ on }">
                                          <v-btn color="primary" class="mr-0 px-0"
                                                 v-on="on"
                                                 small
                                                 @click="openPeek(question)">
                                            <v-icon size="25" color="white">help_outline</v-icon> &nbsp;Peek
                                          </v-btn>
                                        </template>
                                        <span>You don't have COINS. Please earn COINS from LEARN SECTION or PEEK after submit.</span>
                                      </v-tooltip>
                                    </v-flex>

                                    <v-flex class="label ques-indicators wrapword white--text px-0 mt-2"
                                            style="z-index:2">
                                      <a href="javascript:void(0)" v-for="(question, index) in questions" :key="'icon_'+index"
                                         @click="openCard(index+1)">
                                        <img
                                          class="ml-1"
                                          style="background:grey;border-radius: 50%"
                                          :style="(index+1) === e1 ? 'margin-bottom:1px': ''"
                                          :class="(index+1) === e1 ? '': 'mb-1'"
                                          :src="getIndicator(question)"
                                          :height="(index+1) === e1 ? '16': '10'"></a>
                                    </v-flex>

                                    <v-flex class="text-xs-right pl-0">
                                      <v-btn color="primary" outline class="ml-0 px-0"
                                             small
                                             v-if="typeof question.score.scoredValue !== 'undefined'"
                                             :disabled="questionIds.length === 0"
                                             @click="nextAvailableQuestion">
                                        Next <v-icon>arrow_forward</v-icon>
                                      </v-btn>
                                      <v-btn v-else color="primary" class="ml-0"
                                             small
                                             :disabled="typeof question.score.scoredValue !== 'undefined'
                                       || questionIds.length === 0
                                       || answerTxt === ''"
                                             @click="validateAnswer(question, index)">
                                        Submit
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <!---------- /BUTTONS --------------------->

                          </v-stepper-content>

                          <v-layout style="width:100%" row class="nav-btn pa-0" >

                            <v-flex xs6 class="text-xs-left stepper-left-button carousel-stepper-button" >
                              <v-btn  color="grey darken-1" v-if="e1 !== 1" class="elevation-5" @click.prevent="prevSlide" fab small dark>
                                <v-icon  x-large >chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex xs6 class="text-xs-right carousel-stepper-button">
                              <v-btn color="grey darken-1" v-if="questions.length !== e1" class="elevation-5"
                                     @click.prevent="nextSlide" fab small dark>
                                <v-icon x-large >chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-stepper-items>
                      </v-stepper>

                    </v-flex>
                  </v-layout>

                  <v-layout fill-height v-else align-center justify-center>
                    <v-flex style="margin-top:300px;">
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                      >
                        <v-progress-circular indeterminate color="blue lighten-2"></v-progress-circular><span class="title font-weight-light">&nbsp;loading quiz...</span>

                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>

            <!------------- /CONTENT ---------------->

          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>



    <v-dialog
      persistent
      :width="$store.getters.getAppWidth - 10"
      max-width="400px"
      v-model="$store.getters['quiz/getTenQpopupStatus']"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Quiz Result</v-toolbar-title>
<!--          <v-spacer></v-spacer>-->
<!--          <v-toolbar-items>-->
<!--            <v-btn dark flat @click="closeAndGoToProgramLevels">home</v-btn>-->
<!--          </v-toolbar-items>-->
        </v-toolbar>

        <v-card-text>
          <p>{{tenQpopup.first_line}}</p>
          <div class="progress progress-lg" style="border-radius:10px;">
            <div id="tenQprogress_1" :style="{width: tenQpopup.score_in_percent < 5 ? '5%':tenQpopup.score_in_percent+'%'}"
                 class="ten-q-progress progress-bar  progress-bar-default">
              <span class="pull-right userImg" style="position:relative;">

                <img class="progress-user-img elevation-10"
                     :style="{'background-image':userImage(), overflow: 'hidden'}"
                     :src="$store.getters['user/avatar']"></span></div>

            <div id="tenQprogress_2" style="position: relative; width: 6%;" v-if="tenQpopup.score_in_percent < tenQpopup.level_up_cor"
                 :style="{width: (tenQpopup.level_up_cor - tenQpopup.score_in_percent - 1)+'%'}"
                 class="progress-bar  progress-bar-default progress-bar-striped">
            </div>

            <div id="tenQprogress_3" style="position: relative; width: 1%;"  v-if="tenQpopup.score_in_percent < tenQpopup.level_up_cor"
                 class="progress-bar progress-bar-warning">
            </div>
          </div>

          <p>{{tenQpopup.second_line}}</p>
          <p>{{tenQpopup.third_line}}</p>

        </v-card-text>

        <v-divider ></v-divider>

        <v-card-actions>
          <v-btn color="primary" flat @click="closeAndGoToProgramLevels">
            Home
          </v-btn>
          <v-spacer />
          <v-btn color="green" flat @click="fetchNextTestSet">
            Quiz again
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="citationDialog"
      :width="$store.getters.getAppWidth - 10"
    >
      <v-card>
        <div class="panel-footer" >{{citationCardName}}</div>
        <div class="panel-heading" >{{citationViewName}}</div>
        <v-card-text>
          <dl class="dl-horizontal">
            <dt>Image Title</dt>
            <dd>{{citationImageTitle}}</dd>

            <dt>Image Note</dt>
            <dd>{{citationImageNote}}</dd>

            <dt>Description Note</dt>
            <dd>{{citationDescriptionNote}}</dd>
          </dl>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-dialog
      v-model="peekDialog"
      :width="$store.getters.getAppWidth - 10"
    >
      <v-toolbar dark color="primary">
        <v-toolbar-title>Peek (<small>{{tokens}} coins left</small>)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="peekDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card>
        <div class="panel-footer" >{{peekCardName}}</div>
        <div class="panel-heading" >{{peekViewName}}</div>
        <v-card-text>
          <v-img class="grey lighten-3"
                 contain
                 height="300" transition="fade-transition"
                 :src="peekImage">
            <template v-slot:placeholder>
              <v-layout
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>

              </v-layout>
            </template></v-img>

          <v-flex class="pt-4" v-html="peekDescription"></v-flex>

        </v-card-text>

      </v-card>
    </v-dialog>
    <!--10 Q Popup-->

    <v-layout row justify-center>
      <v-dialog v-model="errorDialog" :width="$store.getters.getAppWidth - 10">
        <v-card>
          <v-card-title class="white--text font-weight-light title primary">Confirm</v-card-title>

          <v-card-text >
            <p>Please select any option to continue.</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <!--<v-btn color="" flat  @click="submitWithoutSelection">YES</v-btn>-->
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="errorDialog = false ">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-dialog
      v-model="$store.getters['quiz/getDialogCalculatingScoreStaus']"
      hide-overlay
      persistent
      :width="$store.getters.getAppWidth - 10"
      max-width="400px"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Calculating score &hellip;
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="quickStartDialog"
      max-width="400"
      :width="$store.getters.getAppWidth - 10">
      <v-card>
        <v-card-title class="white--text font-weight-light title primary">Quick Start</v-card-title>

        <v-card-text >
          <p>Answering set of 10 questions builds your skill for each level.</p>
          <p>You'll earn a LEVEL SKILL that is made up of your aggregate score (Level Score) and subject coverage.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeQuickStartDialog">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-layout>
</div>

</template>

<script>
import QuizHeader from '../layouts/QuizHeader'

// let browser = (function () {
//   let test = function (regexp) {
//     return regexp.test(window.navigator.userAgent)
//   }
//   switch (true) {
//     case test(/edge/i):
//       return 'edge'
//     case test(/opr/i) && (!!window.opr || !!window.opera):
//       return 'opera'
//     case test(/chrome/i) && !!window.chrome:
//       return 'chrome'
//     case test(/trident/i) :
//       return 'ie'
//     case test(/firefox/i) :
//       return 'firefox'
//     case test(/safari/i):
//       return 'safari'
//     default:
//       return 'other'
//   }
// })()
export default {
  components: { QuizHeader },
  data () {
    return {
      tenQPopupDialog: false,
      imageHeight: 250,
      errorDialog: false,
      formatting: [],
      apiUrl: process.env.API_URL,
      level: parseInt(this.$route.params.level),
      groupId: parseInt(this.$route.params.groupId),
      deckId: parseInt(this.$route.params.deckId),
      citationImageTitle: '',
      citationImageNote: '',
      citationDescriptionNote: '',
      citationCardName: '',
      citationViewName: '',
      citationDialog: false,
      peekImage: '',
      // peekImageNote: '',
      peekDescription: '',
      peekCardName: '',
      peekViewName: '',
      peekDialog: false,
      answerTxt: '',
      currentQuestionId: -1,
      currentQuestion: '',
      currentAnswer: '',
      currentQuestionIndex: -1,
      quickStartDialog: false,
      questionIds: [],
      isDev: process.env.NODE_ENV === 'development',
      isNextLevelAvail: false,
      nextLevel: -1,
      scrollHeight: 0
    }
  },
  computed: {
    e1: {
      get: function () {
        return parseInt(this.$route.params.step)
      },
      set: function () {
      }
    },
    tenQpopup: function () {
      return this.$store.getters['quiz/getTenQPopup']
    },
    questions: {
      get: function () {
        let questions = this.$store.getters['quiz/getQuizQuestions']
        let questionIds = []
        questions.forEach(question => {
          if (typeof question.score.scoredValue === 'undefined') {
            questionIds.push(question.questionId)
          }
        })
        this.questionIds = questionIds
        return questions
      },
      set: function (data) {
        this.$store.commit('quiz/setQuizQuestions', data)
      }
    },
    appHeight: {
      get: function () {
        return this.scrollHeight
      },
      set: function (height) {
        this.scrollHeight = height
      }
    },
    group () {
      return this.$store.getters['course/getGroups'].find(group => group.groupId === this.groupId)
    },
    tokens: {
      get: function () {
        return parseInt(this.group.tokens)
      },
      set: function () {
      }
    },
    levels: {
      get: function () {
        return this.$store.getters['course/getLevels']
      },
      set: function (levels) {
        this.$store.commit('course/setLevels', levels)
      }
    },
    levelsCount () {
      return this.$store.getters['getLevelsCount']
    }
  },
  created () {
    this.questions = []
    this.fetchTestSet()
    const level = this.level
    const nextLevel = this.level + 1
    // console.log(this.levels)
    if (level <= this.levelsCount) {
      const nextLevelObj = this.levels.find(obj => obj.id === nextLevel)
      // console.log(nextLevelObj)
      if (Object.keys(nextLevelObj.memberLevel).length !== 0) {
        this.isNextLevelAvail = true
        this.nextLevel = nextLevel
      }
    }
  },
  mounted: function () {
    this.scrollHeight = this.$store.getters.getAppHeight - 60
    if (this.$store.getters['getNewUserLoggedIn'] === true && this.$store.getters['getQuizStatus'] === true) {
      this.quickStartDialog = true
    }
    this.$store.commit('user/recordTimeStart', 'Quiz')
  },
  methods: {
    swipe (direction) {
      if (direction === 'Left') {
        this.nextSlide()
      } else if (direction === 'Right') {
        this.prevSlide()
      }
    },
    userImage () {
      return 'static/images/avatar180x.jpg'
    },
    closeQuickStartDialog () {
      this.quickStartDialog = false
      this.$store.commit('setQuizStatus', false)
    },
    closeAndGoToProgramLevels () {
      this.$store.commit('quiz/setTenQpopupStatus', false)
      this.$router.push({name: 'ProgramLevels', params: {deckId: this.deckId, groupId: this.groupId}})
    },
    fetchNextTestSet () {
      this.questions = []
      this.fetchTestSet(true)
      this.$store.commit('quiz/setTenQpopupStatus', false)
    },
    fetchNextLevelTestSet () {
      this.level += 1
      this.$router.push({name: 'Quiz', params: {level: this.level, deckId: this.deckId, groupId: this.groupId, step: 1}})
      this.questions = []
      this.fetchTestSet(true)
      this.$store.commit('quiz/setTenQpopupStatus', false)
    },
    fetchTestSet (first = false) {
      this.$store.dispatch('quiz/fetchTestSet', {
        scheduleId: this.group.scheduleId,
        memberId: this.group.memberId,
        level: this.level,
        groupId: this.groupId,
        deckId: this.deckId
      }).then(res => {
        if (first === true) {
          this.firstSlide()
        }
      })
    },
    updateFitb (val) {
      // console.log('updateFitb', val)
      this.answerTxt = val
    },

    textContentStyleObject (question) {
      // const breakpoint = this.$vuetify.breakpoint.name
      // const breakpoint = 'xs'
      let buttonHeight = 103
      if (question.questionType === 1 && question.answers.length < 2) { // FITB
        buttonHeight += 10
        // if (this.$vuetify.breakpoint.name === 'xs') {
        //   buttonHeight += 10
        // } else {
        //   buttonHeight += 82
        // }
      } else if (question.answers.length === 2) { // TF
        buttonHeight -= 40
        // if (this.$vuetify.breakpoint.name === 'xs') {
        //   buttonHeight -= 40
        // }
      } else if (question.answers.length === 4) { // MC
        buttonHeight += 27
        // if (breakpoint === 'xs') {
        //   buttonHeight += 27
        // }
      }
      // if (breakpoint === 'xs') {
      //   buttonHeight += 20
      // }
      buttonHeight += 105
      // if (this.$vuetify.breakpoint.name === 'xs') {
      //   buttonHeight += 80
      // }
      const userAgent = navigator.userAgent.toLowerCase()
      const isAndroid = userAgent.includes('android')
      if (isAndroid) {
        buttonHeight += 20
      }
      let height = (this.appHeight - this.imageHeight - buttonHeight + 40) + 'px'
      return {
        height
      }
    },
    getIndicator (question) {
      if (typeof question.score.scoredValue === 'undefined') {
        return 'static/images/grey-24.png'
      } else if (question.score.scoredValue === 0) {
        return 'static/images/red-24.png'
      } else if (question.score.scoredValue > 0) {
        return 'static/images/green-24.png'
      }
    },
    updateAnswerTxt (answer) {
      if (this.currentQuestionId !== answer.question_id) {
        this.formatting = []
        this.answerTxt = ''
        this.currentQuestionId = answer.question_id
      }
      setTimeout(() => {
        if (typeof this.formatting !== 'undefined') {
          this.answerTxt = this.formatting.toString()
        }
      }, 50)
    },
    validateAnswer (question, qIndex) {
      if (this.answerTxt.trim() !== '') {
        this.$store.dispatch('quiz/validateAnswer', {
          groupId: this.groupId,
          level: this.level,
          deckId: this.deckId,
          memberId: this.group.memberId,
          scheduleId: this.group.scheduleId,
          question,
          answer: this.formatting.length !== 0 ? this.formatting : this.answerTxt,
          qIndex
        })
      } else {
        this.currentQuestion = question
        this.currentAnswer = this.answerTxt.trim()
        this.currentQuestionIndex = qIndex
        this.errorDialog = true
      }
    },
    openCard (e1) {
      // console.log('Opening Card...')
      this.$router.push({name: 'Quiz', params: {level: this.level, deckId: this.deckId, groupId: this.groupId, step: e1}})
    },
    firstSlide () {
      this.$router.push({name: 'Quiz', params: {level: this.level, deckId: this.deckId, groupId: this.groupId, step: 1}})
    },
    nextAvailableQuestion () {
      // if (this.questions.length !== this.e1) {
      const e1 = this.questions.findIndex(question => question.questionId === this.questionIds[0]) + 1
      this.$router.push({
        name: 'Quiz',
        params: {level: this.level, deckId: this.deckId, groupId: this.groupId, step: e1}
      })
      // }
    },
    nextSlide () {
      if (this.questions.length !== this.e1) {
        const e1 = this.e1 + 1
        this.$router.push({
          name: 'Quiz',
          params: {level: this.level, deckId: this.deckId, groupId: this.groupId, step: e1}
        })
      }
    },
    prevSlide () {
      if (this.e1 !== 1) {
        const e1 = this.e1 - 1
        this.$router.push({
          name: 'Quiz',
          params: {level: this.level, deckId: this.deckId, groupId: this.groupId, step: e1}
        })
      }
    },
    openCitation (view) {
      // console.log(view)
      this.citationDialog = true
      this.citationImageTitle = view.imageResource.caption
      this.citationImageNote = view.imageResource.headers
      this.citationDescriptionNote = view.textResource.headers
      this.citationCardName = view.cardName
      this.citationViewName = view.viewName
    },
    openPeek (question) {
      if (this.tokens > 0 || (typeof question.score.scoredValue !== 'undefined')) {
        this.peekDialog = true
        this.peekImage = this.apiUrl + '/ws/playerservice' + question.peek_imageResource.resourceurl
        this.peekDescription = question.peek_textResource.textcontent
        this.peekCardName = question.cardName
        this.peekViewName = question.viewName
        this.$store.dispatch('quiz/deductCoin', {
          groupId: this.groupId,
          memberId: this.group.memberId,
          scheduleId: this.group.scheduleId,
          questionId: question.questionId,
          tokens: this.tokens,
          isAnswered: typeof question.score.scoredValue !== 'undefined'
        })
      }
    }
  },
  destroyed () {
    this.$store.commit('user/recordTimeEnd', 'Quiz')
  },
  watch: {
    e1 (newVal) {
      this.formatting = []
      this.answerTxt = ''
    },
    formatting (newVal) {
      if (typeof newVal === 'undefined') {
        this.answerTxt = ''
      }
    }
  }
}
</script>

<style lang="" scoped>
  .sfh-login-form{
    padding-top: 0!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Quiz.vue